'use strict';

var _slicedToArray = require("/home/runner/work/nemcaretezpur.com/nemcaretezpur.com/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/home/runner/work/nemcaretezpur.com/nemcaretezpur.com/node_modules/@babel/runtime/helpers/toConsumableArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var isFullwidthCodePoint = require('is-fullwidth-code-point');

var astralRegex = require('astral-regex');

var ansiStyles = require('ansi-styles');

var ESCAPES = ["\x1B", "\x9B"];

var wrapAnsi = function wrapAnsi(code) {
  return "".concat(ESCAPES[0], "[").concat(code, "m");
};

var checkAnsi = function checkAnsi(ansiCodes, isEscapes, endAnsiCode) {
  var output = [];
  ansiCodes = _toConsumableArray(ansiCodes);

  var _iterator = _createForOfIteratorHelper(ansiCodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ansiCode = _step.value;
      var ansiCodeOrigin = ansiCode;

      if (ansiCode.match(';')) {
        ansiCode = ansiCode.split(';')[0][0] + '0';
      }

      var item = ansiStyles.codes.get(parseInt(ansiCode, 10));

      if (item) {
        var indexEscape = ansiCodes.indexOf(item.toString());

        if (indexEscape >= 0) {
          ansiCodes.splice(indexEscape, 1);
        } else {
          output.push(wrapAnsi(isEscapes ? item : ansiCodeOrigin));
        }
      } else if (isEscapes) {
        output.push(wrapAnsi(0));
        break;
      } else {
        output.push(wrapAnsi(ansiCodeOrigin));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (isEscapes) {
    output = output.filter(function (element, index) {
      return output.indexOf(element) === index;
    });

    if (endAnsiCode !== undefined) {
      var fistEscapeCode = wrapAnsi(ansiStyles.codes.get(parseInt(endAnsiCode, 10)));
      output = output.reduce(function (current, next) {
        return next === fistEscapeCode ? [next].concat(_toConsumableArray(current)) : [].concat(_toConsumableArray(current), [next]);
      }, []);
    }
  }

  return output.join('');
};

module.exports = function (string, begin, end) {
  var characters = _toConsumableArray(string.normalize());

  var ansiCodes = [];
  end = typeof end === 'number' ? end : characters.length;
  var isInsideEscape = false;
  var ansiCode;
  var visible = 0;
  var output = '';

  var _iterator2 = _createForOfIteratorHelper(characters.entries()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          index = _step2$value[0],
          character = _step2$value[1];

      var leftEscape = false;

      if (ESCAPES.includes(character)) {
        var code = /\d[^m]*/.exec(string.slice(index, index + 18));
        ansiCode = code && code.length > 0 ? code[0] : undefined;

        if (visible < end) {
          isInsideEscape = true;

          if (ansiCode !== undefined) {
            ansiCodes.push(ansiCode);
          }
        }
      } else if (isInsideEscape && character === 'm') {
        isInsideEscape = false;
        leftEscape = true;
      }

      if (!isInsideEscape && !leftEscape) {
        ++visible;
      }

      if (!astralRegex({
        exact: true
      }).test(character) && isFullwidthCodePoint(character.codePointAt())) {
        ++visible;
      }

      if (visible > begin && visible <= end) {
        output += character;
      } else if (visible === begin && !isInsideEscape && ansiCode !== undefined) {
        output = checkAnsi(ansiCodes);
      } else if (visible >= end) {
        output += checkAnsi(ansiCodes, true, ansiCode);
        break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return output;
};